import { LOCAL_STORAGE_KEYS } from '../../constants';
import { setLocalStorageValue } from '../storage';

export const setIsShowAfterLoginNotifications = (value: unknown) => {
  setLocalStorageValue(
    LOCAL_STORAGE_KEYS.IS_SHOW_AFTER_LOGIN_NOTIFICATIONS,
    value
  );
};
